import req from './RequestService';

const TrackAdminService = {
    markDriverPeriodClosed: (personAssetId, year, month, force, options) => req.post(`trackadmin/markDriverPeriodClosed/${personAssetId}/${year}/${month}` + (force ? `?force=${force}` : ''), undefined, options),
    isDriverPeriodClosed: (personAssetId, year, month, options) => req.get(`trackadmin/isDriverPeriodClosed/${personAssetId}/${year}/${month}`, options),
    markVehiclePeriodClosed: (vehicleAssetId, year, month, force, options) => req.post(`trackadmin/markVehiclePeriodClosed/${vehicleAssetId}/${year}/${month}` + (force ? `?force=${force}` : ''), undefined, options),
    isVehiclePeriodClosed: (vehicleAssetId, year, month, options) => req.get(`trackadmin/isVehiclePeriodClosed/${vehicleAssetId}/${year}/${month}`, options),
}
export default TrackAdminService;
